
import React, { Component, ErrorInfo, ReactNode } from 'react';
import { ErrorFallback } from './ErrorFallback';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

/**
 * Standard React Error Boundary to catch UI crashes.
 * Inherits generic Props and State to provide typed access to this.props and this.state.
 */
// Fix: Import and extend React.Component directly (aliased as Component) to ensure properties like props and setState are inherited correctly.
export class ErrorBoundary extends Component<Props, State> {
  // Fix: Initialize state without the public keyword to match base class property definition.
  state: State = {
    hasError: false
  };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  // Standard lifecycle method for catching errors in descendants.
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  // Fix: Use property initializer to maintain 'this' context, calling setState from the base Component class.
  resetErrorBoundary = () => {
    this.setState({ hasError: false, error: undefined });
  };

  // Fix: Standard render method accessing inherited properties this.props and this.state.
  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      return (
        <ErrorFallback
          error={this.state.error}
          resetErrorBoundary={this.resetErrorBoundary}
        />
      );
    }

    return this.props.children;
  }
}
